import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';
import {
	PostCheckoutPayment,
	PostCheckoutPaymentModel,
	PostCheckoutPaymentParams,
} from 'domain/usecases';

export class RemotePostCheckoutPayment implements PostCheckoutPayment {
	constructor(
		private readonly url: string,
		private readonly httpClient: HttpClient<PostCheckoutPaymentModel>,
	) {}

	async post({signal, ...body}: PostCheckoutPaymentParams): Promise<PostCheckoutPaymentModel> {
		const httpResponse = await this.httpClient.request({
			url: this.url,
			method: 'post',
			body,
			signal,
		});
		switch (httpResponse.status) {
			case HttpStatusCode.ok:
			case HttpStatusCode.created:
				return httpResponse.data;
			default:
				throw new APIError(httpResponse.status, httpResponse.data);
		}
	}
}
